import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const module = {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}

export default module
